import React from 'react';
import CardLayout from '../../../../shared/components/card/CardLayout';
import { formatDate } from '../../../../shared/functions/Functions';
import { useMediaQuery } from '@mui/material';
import { BootstrapBreakpoints } from '../../../../enum/BootstrapBreakpoints';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';

interface InvoiceSubCardSkeletonProps {
    sequenceNumber?: number;
    length?: number;
    dueDate?: string;
}

const InvoiceSubCardSkeleton = ({ sequenceNumber, dueDate, length }: InvoiceSubCardSkeletonProps) => {
    const isMobile = useMediaQuery(`(max-width: ${BootstrapBreakpoints.SM}px)`);
    const skeletonTitle = sequenceNumber + '/' + length;
    const { t } = useTranslation();
    return (
        <>
            <CardLayout classCard="invoice-sub-card mt-2" classBody="invoice-sub-card-skeleton px-3 py-0 ">
                <div className={`card-content ${isMobile && 'position-absolute'}`}>
                    <p
                        className="mb-0"
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify().sanitize(
                                t('influencer.invoice.skeleton_title', {
                                    uploadText: skeletonTitle,
                                    uploadDate: formatDate(dueDate),
                                })
                            ),
                        }}
                    />
                </div>
                <div className="card-info" aria-hidden="true" role="presentation">
                    <div className="info-block">
                        <div className="info-main">undefined</div>
                        <div>Status</div>
                    </div>
                </div>
                <div className="card-info d-none d-md-block" aria-hidden="true" role="presentation">
                    <div className="info-block">
                        <div className="info-main">undefined</div>
                        <div>Upload date</div>
                    </div>
                </div>
                <div className="card-info d-none d-md-block" aria-hidden="true" role="presentation">
                    <div className="info-block">
                        <div className="info-main euro-symbol">undefined</div>
                        <div>undefined</div>
                    </div>
                </div>
                <div className="card-info" aria-hidden="true" role="presentation">
                    <div className="info-block text-end text-primary">undefined</div>
                </div>
            </CardLayout>
        </>
    );
};

export default React.memo(InvoiceSubCardSkeleton);
